import { extractSlicerFilters } from 'utils/powerbi-metadata/slicer-extractor';
import { normalizeFilter } from 'utils/powerbi-metadata/filter-normalizer';
import type { NormalizedFilter } from 'utils/powerbi-metadata/filter-normalizer';
import { extractActivePageName } from 'utils/powerbi-metadata/page-extractor';
import type { ActivePageLike } from 'utils/powerbi-metadata/page-extractor';

interface ReportInstanceLike {
  getActivePage: () => Promise<
    ActivePageLike & { getVisuals: () => Promise<unknown[]> }
  >;
}

export interface ActivePageAndFiltersResult {
  activePage: string | null;
  filters: NormalizedFilter[];
}

export const readActivePageAndSlicerFilters = async (
  reportInstance: ReportInstanceLike | null | undefined
): Promise<ActivePageAndFiltersResult> => {
  if (!reportInstance) {
    return { activePage: null, filters: [] };
  }

  try {
    const activePage = await reportInstance.getActivePage();
    const activePageName = extractActivePageName(activePage);

    const slicerFilters = await extractSlicerFilters(activePage);

    const normalizedFilters = slicerFilters
      .map(normalizeFilter)
      .filter((filter): filter is NormalizedFilter => Boolean(filter));

    return {
      activePage: activePageName,
      filters: normalizedFilters,
    };
  } catch (error) {
    console.error('Error reading Power BI metadata:', error);

    return { activePage: null, filters: [] };
  }
};
